import React, { useState } from 'react';
import PushService from '../../services/pushService';

const STORAGE_KEY = 'push_prompt_dismissed_at';
const REASK_AFTER_MS = 3 * 24 * 60 * 60 * 1000; // repede o card apos 3 dias

/**
 * Card in-app que pede permissao de notificacao push quando o usuario
 * abre o sistema logado e a permissao ainda esta 'default'.
 * - "Ativar" dispara o prompt nativo do navegador (clique = gesto do usuario)
 * - "Agora nao" esconde por 3 dias
 * - Se permissao ja foi concedida/negada, nao aparece
 */
const PushPermissionPrompt: React.FC = () => {
  const [visivel, setVisivel] = useState<boolean>(() => {
    try {
      if (!PushService.suporta()) return false;
      if (Notification.permission !== 'default') return false;
      const dismissed = Number(localStorage.getItem(STORAGE_KEY) || 0);
      return Date.now() - dismissed > REASK_AFTER_MS;
    } catch {
      return false;
    }
  });
  const [ativando, setAtivando] = useState(false);

  if (!visivel) return null;

  const ativar = async () => {
    setAtivando(true);
    try {
      await PushService.inicializar();
    } finally {
      // Se o prompt nativo foi fechado sem decisao (ainda 'default'), o card volta apos o periodo de reexibicao
      try {
        if (Notification.permission === 'default') {
          localStorage.setItem(STORAGE_KEY, String(Date.now()));
        }
      } catch {}
      setVisivel(false);
      setAtivando(false);
    }
  };

  const depois = () => {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch {}
    setVisivel(false);
  };

  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] flex justify-center px-4 pb-4 sm:pb-6 pointer-events-none">
      <div className="pointer-events-auto w-full max-w-md bg-white rounded-2xl shadow-2xl border border-gray-200 p-4 sm:p-5">
        <div className="flex items-start gap-3">
          <img
            src="/notification-icon.png"
            alt="Falcon Hub"
            className="w-12 h-12 rounded-xl object-cover flex-shrink-0"
          />
          <div className="flex-1 min-w-0">
            <h3 className="text-sm font-bold text-gray-900">
              Receba notificações do Falcon Hub
            </h3>
            <p className="text-xs text-gray-500 mt-1 leading-relaxed">
              Seja avisado quando o status do seu agendamento mudar — mesmo com o app fechado.
            </p>
          </div>
          <button
            onClick={depois}
            aria-label="Fechar"
            className="text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0 -mt-1"
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="flex gap-2 mt-4">
          <button
            onClick={depois}
            className="flex-1 px-4 py-2.5 text-sm font-medium text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-xl transition-colors"
          >
            Agora não
          </button>
          <button
            onClick={ativar}
            disabled={ativando}
            className="flex-1 px-4 py-2.5 text-sm font-bold text-white bg-primary-600 hover:bg-primary-700 rounded-xl transition-colors disabled:opacity-60 flex items-center justify-center gap-2"
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
            </svg>
            {ativando ? 'Ativando...' : 'Ativar notificações'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PushPermissionPrompt;
